<template>
  <v-layout justify-center>
    <v-col
      xs="10"
      sm="10"
      md="10"
      lg="7"
      xl="7">
      <v-card
      class="mb-5"
      id="card01">
        <v-app-bar
          app
          absolute
          dark
          color="grey darken-1"
          fixed
          scroll-target="#target"
        >
          <v-toolbar-title>
            <v-icon>
              mdi-home-city
            </v-icon>
            会社情報
          </v-toolbar-title>
        </v-app-bar>
        <v-content>
          <v-layout>
            <v-sheet
            class="overflow-y-auto"
            id="target">
            <v-list :width="listWidth">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-home-city</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>有限会社コニーシステム</v-list-item-title>
                </v-list-item-content>

              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-calendar</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>設立</v-list-item-subtitle>
                  <v-list-item-title>2001年 12月10日</v-list-item-title>
                </v-list-item-content>

              </v-list-item>

              <v-divider inset></v-divider>

              <!-- <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-badge-account-horizontal-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>特定労働者派遣事業</v-list-item-subtitle>
                  <v-list-item-title>特36-300114</v-list-item-title>
                </v-list-item-content>

              </v-list-item>

              <v-divider inset></v-divider> -->

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-account-circle</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>代表取締役</v-list-item-subtitle>
                  <v-list-item-title>小西 健史</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action></v-list-item-action>

                <v-list-item-content>
                  <v-list-item-subtitle>資本金</v-list-item-subtitle>
                  <v-list-item-title>500万円</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>郵便番号</v-list-item-subtitle>
                  <v-list-item-title>〒770-0936</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action></v-list-item-action>

                <v-list-item-content>
                  <v-list-item-subtitle>住所</v-list-item-subtitle>
                  <v-list-item-title>徳島県徳島市中央通<br/>3丁目1番地</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>電話番号</v-list-item-subtitle>
                  <v-list-item-title>088-625-8102</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-action></v-list-item-action>

                <v-list-item-content>
                  <v-list-item-subtitle>FAX番号</v-list-item-subtitle>
                  <v-list-item-title>088-625-8104</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-file-document-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>事業内容</v-list-item-subtitle>
                  <v-list-item-title>
                    ソフトウェア開発、販売、運用保守<br/>
                    研究開発<br/>
                    学会ホームページの制作、運用保守<br/>
                    学術研究機関向ホームページの制作、運用保守<br/>
                    受託開発
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </v-sheet>
          </v-layout>
        </v-content>
      </v-card>
    </v-col>
  </v-layout>
</template>

<style>
.v-list-item__title {
  white-space: normal !important;
}
.v-list-item__subtitle {
  white-space: normal !important;
}
main.v-content {
  padding-top: 60px !important;
}
</style>

<script>
export default {
  data: () => ({
    // リサイズイベント用 初期値0
    listWidth: 0
  }),
  methods: {
  // 画面幅を特定し、コンテンツ幅、高さを切り替え
    changeListWidth () {
    }
  },
  created () {
    window.addEventListener('resize', this.changeListWidth)
  },
  // DOM作成の際に画面幅特定イベントを登録
  mounted () {
    var cardWidth = document.getElementById('card01').clientWidth
    this.listWidth = cardWidth
  }
}
</script>
